import React from "react";

import { Typography } from "@material-ui/core";

const AverageDailyFootfallTitle: React.FC = () => {
    return (
        <Typography variant="h6" component="div" gutterBottom>
            Footfall level by time of day
        </Typography>
    );
};

export default AverageDailyFootfallTitle;
